import { getLoaderEndpoint } from "@app/framework/loader";
import { pageHead } from "@app/framework/meta";
import { Header } from "@design-system/layouts";
import { NotFoundPage } from "@modules/not-found/pages";
import { SectorDetailsPage } from "@modules/sectors/pages";
import { getSectorService } from "@modules/sectors/services";
import { trans } from "@mongez/localization";
import { LoaderFunctionArgs, MetaFunction } from "@remix-run/node";
import { useLoaderData } from "@remix-run/react";

export async function loader({ request, params }: LoaderFunctionArgs) {
  const { slug } = params;

  const { http, success, catchErrors, notFound } =
    await getLoaderEndpoint(request);

  try {
    const response = await getSectorService(http, slug!);

    return success(response);
  } catch (error: any) {
    // If API returns 404, handle it
    if (error?.response?.status === 404) {
      return notFound({
        error: "Sector not found",
      });
    }
    return catchErrors(error);
  }
}

export default function SectorDetails() {
  const { sector } = useLoaderData<typeof loader>();

  if (!sector) {
    return (
      <>
        <Header />
        <NotFoundPage />;
      </>
    );
  }

  return <SectorDetailsPage sector={sector} />;
}

export const meta: MetaFunction = ({ data }: any) => {
  return pageHead({
    title: trans(data?.sector?.title || "sectorNotFound.title"),
    description: trans(
      data?.sector?.description || "sectorNotFound.description",
    ),
    appendAppName: true,
  });
};
